import { domReady } from '../modules/utils.js';

class ScrollCards extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();

    this.refs = {
      viewport: this.querySelector('.scrollcards-viewport'),
      track: this.querySelector('.scrollcards-track'),
      cards: Array.from(this.querySelectorAll('.scrollcards-card')),
      bkgItems: Array.from(this.querySelectorAll('.scrollcards-bkg-item')),
    };

    if (!this.refs.viewport || !this.refs.track || !this.refs.cards.length) return;

    this.distance = 0;
    this.activeIndex = -1;
    this.ticking = false;

    this.#setListeners();
    this.#measure();
    this.#update();
  }

  disconnectedCallback() {
    this.#unsetListeners();
  }

  #setListeners() {
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onResize);
    this.resizeObserver = new ResizeObserver(this.#onResize);
    this.resizeObserver.observe(this.refs.track);
    this.resizeObserver.observe(this.refs.viewport);
  }

  #unsetListeners() {
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onResize);
    this.resizeObserver?.disconnect();
  }

  #onScroll = () => {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.#update();
      this.ticking = false;
    });
  };

  #onResize = () => {
    this.#measure();
    this.#update();
  };

  #measure() {
    const trackWidth = this.refs.track.scrollWidth;
    const viewportWidth = this.refs.viewport.clientWidth;
    this.distance = Math.max(0, trackWidth - viewportWidth);
    this.style.height = this.distance ? `calc(100dvh + ${this.distance}px)` : '100dvh';
  }

  #update() {
    if (!this.distance) {
      this.refs.track.style.transform = 'translateX(0)';
      this.#setActive(0);
      return;
    }

    const rect = this.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, -rect.top / this.distance));

    this.refs.track.style.transform = `translateX(${-progress * this.distance}px)`;
    this.#setActive(Math.round(progress * (this.refs.cards.length - 1)));
  }

  #setActive(index) {
    if (index === this.activeIndex) return;
    this.activeIndex = index;

    this.refs.cards.forEach((card, i) => {
      card.classList.toggle('is-active', i === index);
    });
    this.refs.bkgItems.forEach((bkg) => {
      bkg.classList.toggle('is-active', bkg.dataset.scrollcardsBkg === String(index));
    });
  }
}

customElements.define('scroll-cards', ScrollCards);
